document.addEventListener('DOMContentLoaded', function() {
  var flexContinueBtn = document.getElementById('js-paychex-flex-sign-in-continue');
  if (flexContinueBtn) {
    flexContinueBtn.addEventListener('click', function() {
      document.getElementById('js-paychex-flex-sign-in-progress').classList.remove('d-none');
      flexContinueBtn.classList.add('d-none');
    });
  }

  var continueBtn = document.getElementById('js-internal-sso-continue-btn');
  if (!continueBtn) return;

  var form = document.getElementById('js-internal-sso-form');
  var checkEmailUrl = form ? form.dataset.checkEmailUrl : null;
  if (!checkEmailUrl) return;
  // PFL-53955: re-enable with the non-integrated client SSO work.
  // var nonIntegratedClientSso = form.dataset.nonIntegratedClientSso === 'true';

  // Intercept Enter key on the email field — trigger continue instead of form submit
  var emailInputEl = document.getElementById('js-internal-sso-email');
  if (emailInputEl) {
    emailInputEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && continueBtn.style.display !== 'none' && !continueBtn.disabled) {
        e.preventDefault();
        continueBtn.click();
      }
    });
  }

  continueBtn.addEventListener('click', function() {
    var emailInput = document.getElementById('js-internal-sso-email');
    var email = emailInput.value.trim();
    var emailRegex = /^[^@\s]+@[^@\s]+$/;
    if (!email || !emailRegex.test(email)) {
      emailInput.setCustomValidity('Please enter a valid Email');
      emailInput.reportValidity();
      return;
    }
    // PFL-53955: restore this branching (allow usernames) with the non-integrated client SSO work.
    // if (!nonIntegratedClientSso) {
    //   var emailRegex = /^[^@\s]+@[^@\s]+$/;
    //   if (!email || !emailRegex.test(email)) {
    //     emailInput.setCustomValidity('Please enter a valid Email');
    //     emailInput.reportValidity();
    //     return;
    //   }
    // } else if (!email) {
    //   emailInput.reportValidity();
    //   return;
    // }
    emailInput.setCustomValidity('');

    continueBtn.disabled = true;
    continueBtn.textContent = 'Please wait...';
    document.getElementById('js-internal-sso-error').style.display = 'none';

    var csrfToken = document.querySelector('meta[name="csrf-token"]');

    fetch(checkEmailUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': csrfToken ? csrfToken.getAttribute('content') : '',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: 'email_or_username=' + encodeURIComponent(email)
    })
    .then(function(response) { return response.json().then(function(data) { return { ok: response.ok, status: response.status, data: data }; }); })
    .then(function(result) {
      if (!result.ok) {
        if (result.status === 429) {
          showFlashError((result.data && result.data.message) ? result.data.message : 'Too many attempts. Please try again later.');
          continueBtn.disabled = false;
          continueBtn.textContent = 'Continue';
        } else {
          showFlashError((result.data && result.data.message) ? result.data.message : 'An error occurred. Please try again.');
          continueBtn.disabled = false;
          continueBtn.textContent = 'Continue';
        }
        return;
      }
      var data = result.data;
      if (data.status === 'sso') {
        var ssoRedirectUrl = form.dataset.ssoRedirectUrl || '';
        if (ssoRedirectUrl && /^\//.test(ssoRedirectUrl)) {
          window.location.href = ssoRedirectUrl;
        } else {
          showFlashError('An error occurred. Please try again.');
          continueBtn.disabled = false;
          continueBtn.textContent = 'Continue';
        }
      } else if (data.status === 'mfa') {
        goToPasswordScreen(emailInput);
      }
    })
    .catch(function() {
      showFlashError('An error occurred. Please try again.');
      continueBtn.disabled = false;
      continueBtn.textContent = 'Continue';
    });
  });

  var backBtn = document.getElementById('js-internal-sso-back-btn');
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      var emailInput = document.getElementById('js-internal-sso-email');
      emailInput.readOnly = false;
      emailInput.value = '';
      emailInput.focus();
      document.getElementById('js-internal-sso-password-section').style.display = 'none';
      document.getElementById('js-internal-sso-signin-btn').style.display = 'none';
      document.getElementById('js-internal-sso-error').style.display = 'none';
      backBtn.style.display = 'none';
      continueBtn.style.display = 'block';
      continueBtn.disabled = false;
      continueBtn.textContent = 'Continue';
      var altOptions = document.getElementById('js-internal-sso-alt-options');
      if (altOptions) { altOptions.style.display = 'block'; }
      var pwdInput = document.getElementById('js-internal-sso-password');
      if (pwdInput) { pwdInput.value = ''; pwdInput.required = false; }
      clearFlashError();
    });
  }

  function goToPasswordScreen(emailInput) {
    emailInput.readOnly = true;
    document.getElementById('js-internal-sso-password-section').style.display = 'block';
    continueBtn.style.display = 'none';
    document.getElementById('js-internal-sso-signin-btn').style.display = 'block';
    document.getElementById('js-internal-sso-back-btn').style.display = 'inline-block';
    var altOptions = document.getElementById('js-internal-sso-alt-options');
    if (altOptions) { altOptions.style.display = 'none'; }
    var pwdInput = document.getElementById('js-internal-sso-password');
    if (pwdInput) { pwdInput.value = ''; pwdInput.required = true; pwdInput.focus(); }
  }

  function showFlashError(message) {
    clearFlashError();
    var flashArea = document.getElementById('flash-area');
    if (!flashArea) return;
    var div = document.createElement('div');
    div.id = 'js-sso-flash-error';
    div.className = 'alert alert--sticky alert-info-icon alert-danger';
    var body = document.createElement('div');
    body.className = 'alert__body';
    body.textContent = message;
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'close';
    closeBtn.setAttribute('aria-hidden', 'true');
    closeBtn.textContent = '\u00d7';
    closeBtn.addEventListener('click', function() { div.remove(); });
    div.appendChild(body);
    div.appendChild(closeBtn);
    flashArea.appendChild(div);
    div.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function() { if (div.parentNode) { div.remove(); } }, 5000);
  }

  function clearFlashError() {
    var existing = document.getElementById('js-sso-flash-error');
    if (existing) existing.remove();
  }
});
